import { useCallback } from 'react'

export default ({
  onChange,
  model,
  field: variationField,
  setShowTranslatesModal,
  showTranslatesModal,
}) => {

  const handleCategoryRename = useCallback(({ field, translates }) => {
    setShowTranslatesModal({
      field: `values[${variationField}].sections[${field}].title`,
      translates,
    })
  }, [setShowTranslatesModal, variationField])

  const handleChangeCategoryTranslate = useCallback(translates => {
    const { field } = showTranslatesModal
    onChange({
      target: {
        value: translates,
        name: field,
      },
    })
    setShowTranslatesModal(null)
  },[onChange, setShowTranslatesModal, showTranslatesModal])

  const handleAddCategory = useCallback(() => {
    setShowTranslatesModal({
      new: true,
      translates: {},
    })
  },[setShowTranslatesModal])

  const handleCreateCategory = useCallback(translates => {
    onChange({
      target: {
        value: [...(model.values[variationField].sections || []), {
          title: translates,
          ingredients: [],
        }],
        name: `values[${variationField}].sections`,
      },
    })
    setShowTranslatesModal(null)
  }, [model.values, onChange, setShowTranslatesModal, variationField])

  return {
    handleCategoryRename,
    handleChangeCategoryTranslate,
    handleAddCategory,
    handleCreateCategory,
  }
}
